
define('template!webshopLandingpagesDetailBodyTextsLanguageView', ['lodash'], function(_) {return function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape;
with (obj) {
__p += '<div class="header">\n    <div class="language">' +
((__t = ( language )) == null ? '' : __t) +
'</div>\n</div>\n<div class="body">\n    <div class="texts">\n        <div class="name item">\n            <div class="libelle">' +
((__t = ( _.i18n('common.name') )) == null ? '' : __t) +
'</div>\n            <input type="text" value="' +
((__t = ( name )) == null ? '' : __t) +
'">\n        </div>\n        <div class="slug item">\n            <div class="libelle">' +
((__t = ( _.i18n('common.slug') )) == null ? '' : __t) +
'</div>\n            <input type="text" value="' +
((__t = ( slug )) == null ? '' : __t) +
'">\n        </div>       \n    </div>    \n    <div class="seo">\n        <div class="title">' +
((__t = ( _.i18n('common.seo') )) == null ? '' : __t) +
'</div>\n        <div class="meta-title item">\n            <div class="libelle">' +
((__t = ( _.i18n('common.meta-title') )) == null ? '' : __t) +
'</div>\n            <input type="text" value="' +
((__t = ( metaTitle )) == null ? '' : __t) +
'">\n        </div>\n        <div class="meta-description item">\n            <div class="libelle">' +
((__t = ( _.i18n('common.meta-description') )) == null ? '' : __t) +
'</div>\n            <textarea>' +
((__t = ( metaDescription )) == null ? '' : __t) +
'</textarea>\n        </div>\n    </div>   \n</div>\n';

}
return __p
};});

